import {Field} from 'formik';

import {
    FormikSelect,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset,
} from '@flexinet/ui-components';
import {
    Alert,
    Stack,
} from '@mantine/core';
import {AiOutlineInfoCircle} from 'react-icons/ai';

import {TestDefinitionStatus} from '../types.ts';
import {StepsField} from './StepsField.tsx';
import {ApplicationField} from '../../testing-api-integration/components/ApplicationField.tsx';

const STATUS_OPTIONS = [
    {
        label: 'Draft',
        value: TestDefinitionStatus.DRAFT,
    },
    {
        label: 'Active',
        value: TestDefinitionStatus.ACTIVE,
    },
    {
        label: 'Retired',
        value: TestDefinitionStatus.RETIRED,
    },
];

export const FormComponent = ({editing = false}: { editing?: boolean }) => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Test Definition Details'}>

                <Field
                    name='testCode'
                    label='Test Code'
                    description='The handle this test is dispatched on, e.g. "signup.happy-path". Free text.'
                    placeholder='signup.happy-path'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='name'
                    label='Name'
                    description='Human-friendly name shown in the catalog'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='What this test covers'
                    component={FormikTextarea}
                    my={'xl'}
                />

                {/* FNP-979: a real foreign key into the console application
                    catalog, not a hand-typed label. Optional by design — see
                    ApplicationField. ⚠️ On a TestDefinition this is
                    LOAD-BEARING: the executor resolves the application's `url`
                    to pick the base URL for a wake. */}
                <ApplicationField
                    description='The application this test drives. Its URL is what the executor navigates to on a wake.'
                />

                {editing ? (
                    <Alert
                        icon={<AiOutlineInfoCircle/>}
                        color='blue'
                        my={'xl'}
                        title='Status is changed separately'
                    >
                        Use the Activate / Retire buttons on the test definition page.
                        Status transitions are validated by the server, so they are not
                        part of this form.
                    </Alert>
                ) : (
                    /* No default is seeded — the author chooses explicitly.
                       TestDefinitionStatus! is NonNull with no server default. */
                    <Field
                        name='status'
                        label='Status'
                        description='Required. Only ACTIVE test definitions are eligible to run.'
                        placeholder='Select a status'
                        component={FormikSelect}
                        data={STATUS_OPTIONS}
                        withAsterisk
                        my={'xl'}
                    />
                )}

            </PlatformFieldset>

            <PlatformFieldset legend={'Steps'}>
                <StepsField/>
            </PlatformFieldset>
        </Stack>
    );
};
